<div class="menu emds">
  <div class="nav">
    <mat-icon [matMenuTriggerFor]="menu" class="material-icons md-36">{{matIconName}}</mat-icon>
      <mat-menu #menu="matMenu">
        <button *ngFor="let buttonInfo of dropdownList"
        id="{{Id}}-dropdown-{{buttonInfo.ButtonName}}"
        mat-menu-item 
        (click)="buttonInfo.Callback(dataItem)"
         translate>{{buttonInfo.ButtonName}}</button>
      </mat-menu>
  </div>
</div>
